import React from 'react';
import { Link } from 'react-router-dom';
import { ToolbarGroup } from 'material-ui/Toolbar';
import FlatButton from 'material-ui/FlatButton';
import AddIcon from 'material-ui/svg-icons/content/add-box';
import FloorIcon from 'material-ui/svg-icons/action/line-weight';
import BuildingIcon from 'material-ui/svg-icons/communication/business';
import MarkerIcon from 'material-ui/svg-icons/maps/place';
import style from './style.js';

const Breadcrumb = ({ match, breadcrumbs, breadCrumbWidth }) => {
  if (!match.path.startsWith('/map') && !match.path.startsWith('/facilities')) {
    return null;
  }

  const { facility, building, floor, marker } = breadcrumbs;
  const parts = match.path.split('/');
  const pathParts = parts
    .slice(1, parts.length)
    .filter(path => path && path !== 'facilities' && path !== ':facilityId');
  const baseUrl = match.path.startsWith('/map') ? '/map' : '/facilities';
  // Get the max width for each button pending how many there are and
  // based on the parent's width. 70px comes from the extra margin
  // and padding in the buttons.
  const maxWidth = breadCrumbWidth / Math.ceil(pathParts.length / 2) - 70;
  return (
    <div>
      {pathParts.map((path, index) => {
        const isLast = pathParts.length <= index + 1;
        if (path === 'buildings' && isLast) {
          return (
            <BreadcrumbButton
              icon={<AddIcon />}
              key={index}
              isLast={isLast}
              label="New Buidling"
              to={`${baseUrl}/${facility._id}/buildings`}
              maxWidth={maxWidth}
            />
          );
        } else if (path === ':buildingId' && building) {
          return (
            <BreadcrumbButton
              icon={<BuildingIcon />}
              key={index}
              isLast={isLast}
              label={building.name}
              to={`${baseUrl}/${facility._id}/buildings/${building._id}`}
              maxWidth={maxWidth}
            />
          );
        } else if (path === 'floors' && isLast) {
          return (
            <BreadcrumbButton
              icon={<AddIcon />}
              key={index}
              isLast={isLast}
              label="New Floor"
              to={`${baseUrl}/${facility._id}/buildings/${building._id}/floors`}
              maxWidth={maxWidth}
            />
          );
        } else if (path === ':floorId' && floor) {
          return (
            <BreadcrumbButton
              icon={<FloorIcon />}
              key={index}
              isLast={isLast}
              label={floor.name}
              to={`${baseUrl}/${facility._id}/buildings/${
                building._id
              }/floors/${floor._id}`}
              maxWidth={maxWidth}
            />
          );
        } else if (path === 'markers' && isLast) {
          return (
            <BreadcrumbButton
              icon={<AddIcon />}
              key={index}
              isLast={isLast}
              label="New Marker"
              to={`${baseUrl}/${facility._id}/buildings/${
                building._id
              }/floors/${floor._id}/markers`}
              maxWidth={maxWidth}
            />
          );
        } else if (path === ':markerId' && marker) {
          return (
            <BreadcrumbButton
              icon={<MarkerIcon />}
              key={index}
              isLast={isLast}
              label={marker.name}
              to={`${baseUrl}/${facility._id}/buildings/${
                building._id
              }/floors/${floor._id}/markers/${marker._id}`}
              maxWidth={maxWidth}
            />
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

const BreadcrumbButton = ({ isLast, label, to, icon, maxWidth }) => (
  <div style={style.breadcrumbDisplay}>
    <div style={style.breadcrumbContainer}>
      <FlatButton
        labelStyle={{ ...style.labelStyle, maxWidth }}
        style={isLast ? style.isLastButton : style.button}
        disabled={isLast}
        label={label}
        icon={icon}
        containerElement={<Link to={to} />}
      />
      {!isLast && <span style={style.breadcrumbSeparator}> / </span>}
    </div>
  </div>
);

export default class BreadcrumbBar extends React.Component {
  render() {
    const { match, breadcrumbs, windowWidth } = this.props;
    const breadCrumbWidth = windowWidth - 587 - 15;
    return (
      <ToolbarGroup
        style={{
          ...style.breadcrumbGroup,
          width: breadCrumbWidth
        }}
      >
        <Breadcrumb
          match={match}
          breadcrumbs={breadcrumbs}
          breadCrumbWidth={breadCrumbWidth}
        />
      </ToolbarGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NavBar/BreadcrumbBar.js